import { useState } from 'react';
import { useProfile } from '../../context/ProfileContext';
import { RiMagicLine } from 'react-icons/ri';

// Components
import ResumeSection from '../../components/profile/ResumeSection';
import ExperienceSection from '../../components/profile/ExperienceSection';
import EducationSection from '../../components/profile/EducationSection';
import SkillsSection from '../../components/profile/SkillsSection';
import PortfolioSection from '../../components/profile/PortfolioSection';
import PopulateProfileModal from '../../components/profile/PopulateProfileModal';

export default function ProfileOverview() {
    const { data: fullData } = useProfile();
    const [isPopulateModalOpen, setIsPopulateModalOpen] = useState(false);

    if (!fullData) return null; // Should be handled by layout loading state

    // Find default resume for display in modal
    const defaultResume = fullData.resumes.find(r => r.is_default) || fullData.resumes[0];

    return (
        <div className="space-y-6">
            {/* Header Action */}
            <div className="flex justify-end">
                <button
                    onClick={() => setIsPopulateModalOpen(true)}
                    className="group flex items-center gap-2 px-4 py-2 rounded-xl bg-gradient-to-r from-blue-600 to-blue-500 hover:from-blue-500 hover:to-blue-400 text-white shadow-lg shadow-blue-500/20 transition-all hover:scale-[1.02] active:scale-[0.98]"
                >
                    <RiMagicLine className="animate-pulse" />
                    <span className="font-semibold text-sm">Auto-fill from Resume</span>
                </button>
            </div>

            {/* 1. Resume */}
            <ResumeSection resumes={fullData.resumes} />

            {/* 2. Experience */}
            <ExperienceSection experiences={fullData.work_experiences} />

            {/* 3. Education */}
            <EducationSection educations={fullData.educations} />

            {/* 4. Skills */}
            <SkillsSection skills={fullData.skills} />

            {/* 5. Portfolio */}
            <PortfolioSection links={fullData.links} />

            <PopulateProfileModal
                isOpen={isPopulateModalOpen}
                onClose={() => setIsPopulateModalOpen(false)}
                defaultResumeName={defaultResume?.name}
                defaultResumeId={defaultResume?.id}
            />
        </div>
    );
}
